"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _moment = _interopRequireDefault(require("moment"));
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _pluralTranslations = require("../../../../../../localization/pluralTranslations");
var _handlers = require("../../../../../../helpers/handlers");
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _selectors = require("../../../../store/selectors");
var _Claim = require("../Claim");
var _helpers = require("../../helpers");
var _send = _interopRequireDefault(require("./img/send.svg"));
var _angleDown = _interopRequireDefault(require("./img/angleDown.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject; // import ViewedIcon from './img/eye.svg';
// import ArrowIcon from './img/arrow.svg';
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledLink = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    :hover {\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});
var Basket = function Basket(_ref) {
  var basketID = _ref.basketID,
    className = _ref.className,
    _ref$initialOpen = _ref.initialOpen,
    initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen,
    stylesMap = _ref.stylesMap,
    children = _ref.children;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getBasketById)(state, {
        basketID: basketID
      });
    }),
    title = _useSelector.title,
    offersIDs = _useSelector.offersIDs,
    user = _useSelector.user,
    emails = _useSelector.emails,
    claim = _useSelector.claim,
    date = _useSelector.date,
    image = _useSelector.image;
  var _useState = (0, _react.useState)(initialOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var toursTranslation = (0, _pluralTranslations.usePluralToursTranslation)();
  var offersCount = R.length(offersIDs);
  var openedClassName = (stylesMap === null || stylesMap === void 0 ? void 0 : stylesMap.opened) || _styles.default.opened;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.container, className, _defineProperty({}, openedClassName, open)),
    id: (0, _helpers.createBasketId)(basketID)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.item, stylesMap === null || stylesMap === void 0 ? void 0 : stylesMap.item, _defineProperty({}, _styles.default.opened, open)),
    onClick: function onClick() {
      setOpen(function (prev) {
        return !prev;
      });
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.imgCol,
    style: {
      backgroundImage: "url(\"".concat((0, _dictionary.getImageUrl)(image, 'small'), "\")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.col, _styles.default.tourCol, stylesMap === null || stylesMap === void 0 ? void 0 : stylesMap.tourCol)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.tourRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.name
  }, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.secondLine
  }, "".concat(offersCount, " ").concat(toursTranslation(offersCount)))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.col, _styles.default.nameCol)
  }, user && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.tourRow
  }, user.username), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.secondLine
  }, (0, _moment.default)(date).format('DD MMM HH:mm'))), (claim || !R.isEmpty(emails)) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.col, _styles.default.infoCol)
  }, claim && /*#__PURE__*/_react.default.createElement(_Claim.Claim, {
    description: claim.claimDesc,
    claimID: claim.id,
    link: claim.claimLink,
    basketID: basketID
  }), !R.isEmpty(emails) && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.infoRow
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.icon,
    dangerouslySetInnerHTML: {
      __html: _send.default
    }
  }), R.map(function (_ref2) {
    var email = _ref2.email,
      id = _ref2.id;
    return /*#__PURE__*/_react.default.createElement(StyledLink, {
      onClick: _handlers.stop,
      href: "mailto:".concat(email),
      key: id
    }, email);
  }, emails))), /*#__PURE__*/_react.default.createElement(_Button.default, {
    circle: true,
    className: (0, _classnames3.default)(_styles.default.button, stylesMap === null || stylesMap === void 0 ? void 0 : stylesMap.button, open && _styles.default.isCollapsed),
    icon: _angleDown.default,
    size: _Button.SIZES.MEDIUM,
    theme: _Button.THEMES.WHITE,
    activeTheme: _Button.THEMES.WHITE
  })), open && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.children, stylesMap === null || stylesMap === void 0 ? void 0 : stylesMap.children)
  }, children));
};
Basket.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  initialOpen: _propTypes.default.bool
};
var _default = exports.default = (0, _react.memo)(Basket);